import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
import { select, Store } from '@ngrx/store';
import { currentAuthToken, currentUser } from '../../../../../../core/auth';
import { AppState } from '../../../../../../core/reducers';
import { HttpClient } from '@angular/common/http';
import {
  HttpUtilsService,
  LayoutUtilsService,
  MessageType,
} from '../../../../../../core/_base/crud';

@Component({
  selector: 'kt-admin-add-tags-dialog',
  templateUrl: './admin-add-tags-dialog.component.html',
  styleUrls: ['./admin-add-tags-dialog.component.scss'],
})
export class AdminAddTagsDialogComponent implements OnInit {
  disableBtns = false;
  tags = new FormControl(null, Validators.required);
  private companyId: any;
  private authToken: any;
  tagsForm: FormGroup;

  constructor(
    private layoutUtilsService: LayoutUtilsService,
    private httpClient: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AdminAddTagsDialogComponent>,
    private fb: FormBuilder,
  ) {
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
  }

  ngOnInit(): void {
    this.tagsForm = this.fb.group({
      entity_type: [undefined, Validators.required],
    });
  }

  onCancelClick() {
    this.close(false);
  }

  onSubmit() {
    this.tagsForm.markAllAsTouched();
    this.tags.markAsTouched();

    if (this.tagsForm.invalid || this.tags.invalid || !this.tags.value?.length) return;

    const body = {
      tags: (this.tags.value || []).map((e) => e.name),
      type: this.tagsForm.get('entity_type').value,
    };
    this.saveTags(body).subscribe(() => {
      this.layoutUtilsService.showActionNotification(
        'Tags have been created',
        MessageType.Create,
        3000,
        false,
        false,
      );

      this.close(true);
    });
  }

  private close(needReload: boolean) {
    this.dialogRef.close({
      reload: needReload,
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.tagsForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  private saveTags(body: { type: any; tags: any }): Observable<any> {
    this.disableBtns = true;
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.httpClient.post<any>(
      `${environment.CORE_BASE}/companies/${this.companyId}/tags`,
      body,
      { headers: httpHeaders },
    );
  }
}
